(function() {

'use strict';
  
a3_cabin_reports.filter('bytes', bytes);
    
    /**
    * @memberof CabinReports
    * @ngdoc filter
    * @name bytes
    * @description 
    *  Transform Bytes to  'kB', 'MB', 'GB', 'TB', 'PB'
    * @ngInject
    */                       
function bytes() {
		return function(bytes, precision) {
			if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
			if (typeof precision === 'undefined') precision = 1;
			var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
				number = Math.floor(Math.log(bytes) / Math.log(1024));
			return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
		}
	}

    
})();
